import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogCategorySplit',
})(({ spacing, brandColors }) => ({
  divWrapper: {
    backgroundColor: brandColors.tintsOffWhite60,
  },
  grid: {
    rowGap: spacing(3),
  },
}));

export default useStyles;
